import { Immutable } from "immer";
import React from "react";
import { usePageSetting } from "tsi-common-react/src/utils/settings";

import { NearbyStoresSearch } from "../../apps/retail-locator/NearbyStoresSearch";
import { SiteSearchBar } from "../SiteSearchBar";

type IProps = Immutable<{
    isSearchOpen: boolean;
    onOpenSearch: () => void;
    onCloseSearch: () => void;
}>;

export const SearchNav = ({
    isSearchOpen,
    onOpenSearch,
    onCloseSearch,
}: IProps): React.ReactNode => {
    const enableStoreSearch = usePageSetting("retail_locator_display_enabled");

    return (
        <>
            {enableStoreSearch && (
                <NearbyStoresSearch isSiteSearchOpen={isSearchOpen} />
            )}
            <SiteSearchBar
                isSearchOpen={isSearchOpen}
                onOpenSearch={onOpenSearch}
                onCloseSearch={onCloseSearch}
            />
        </>
    );
};
